import { CustomGridColumns } from '../../CustomDataGrid';

export const ibsCbsColumns: CustomGridColumns[] = [
  {
    field: 'cod_ibs_cbs',
    headerName: 'Cod. IBS/CBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'des_classif_trib_ibs_cbs',
    headerName: 'Classif. IBS/CBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'val_bc_ibs_cbs_final',
    headerName: 'BC IBS/CBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'per_aliq_cbs',
    headerName: 'Alíq. CBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'per_red_cbs',
    headerName: 'Red. CBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'val_cbs',
    headerName: 'Val. CBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'per_aliq_ibs_est',
    headerName: 'Alíq. IBS Est',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'val_ibs_est',
    headerName: 'Val. IBS Est.',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'per_aliq_ibs_mun',
    headerName: 'Alíq. IBS Mun.',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'per_red_ibs',
    headerName: 'Red. IBS',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
  {
    field: 'val_ibs_mun',
    headerName: 'Val. IBS Mun.',
    width: 100,
    sortable: false,
    disableColumnMenu: true,
    format: 'number',
  },
];
